import { Component,Inject,OnInit } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router'; 
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OktaAuth } from '@okta/okta-auth-js';
import { ApiService } from './utility/api.service';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink,CommonModule,RouterModule,
    FormsModule,],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit  {
  menuOpen = false;
  profileOpen = false;
  title = 'aims-angular-ui';
  user: any = null;
  isAuthenticated = false;

  async logout(): Promise<void> {
  this.profileOpen = false;
  this.menuOpen = false;
  this.user = null;
  this.isAuthenticated = false;

  await this.apiService.logout();
}

  getInitials(name: string): string {
  if (!name) {
    return '';
  }

  return name
    .trim()
    .split(/\s+/)
    .map(part => part[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();
  }

  constructor(
    private oktaAuthStateService: OktaAuthStateService,
    private apiService: ApiService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    
  ) {}

  ngOnInit() {
    // Subscribe to authentication state changes
    this.oktaAuthStateService.authState$.subscribe(async (authState) => {
      this.isAuthenticated = !!authState.isAuthenticated;
      if (this.isAuthenticated) {
        this.user = await this.oktaAuth.getUser(); 
      } else {
        this.user = null;
      }
    });
}
}
 